
export default {
  name: 'icon-analytics-airport',
};
